import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AdminTableComponent from 'routes/Admin/components/CommonComponents/AdminTableComponent'
import { tableTypesMatcher } from 'utils/labelMatcher'
import {
  MODAL_ADMIN_EDIT_PRICING,
  MODAL_ADMIN_CREATE_PRICING,
  MODAL_ADMIN_DELETE_PRICING
} from 'redux/modules/modals'
const defaultColumnData = [
  { id: 'name', numeric: false, disablePadding: true, label: 'Nom' },
  {
    id: 'type',
    type: 'pricing',
    numeric: false,
    disablePadding: false,
    label: 'Type'
  },
  { id: 'color', numeric: false, disablePadding: true, label: 'Couleur' },
  {
    id: 'isPlanned',
    numeric: true,
    bool: true,
    disablePadding: false,
    label: 'Planning'
  }
]
export default class AdminPricingsComponent extends Component {
  static propTypes = {
    tableTypes: PropTypes.object.isRequired,
    pricings: PropTypes.array.isRequired,
    showModal: PropTypes.func.isRequired
  }
  state = {
    columnData: []
  }
  handleAddPricingClick = () => {
    this.props.showModal(MODAL_ADMIN_CREATE_PRICING)
  }
  handleEditPricingClick = pricing => {
    this.props.showModal(MODAL_ADMIN_EDIT_PRICING, pricing)
  }
  handleDeletePricingClick = pricing => {
    this.props.showModal(MODAL_ADMIN_DELETE_PRICING, pricing)
  }
  handleReorderClick = () => {}
  updateColumnData = tableTypes => {
    const columnData = [...this.state.columnData]
    Object.keys(tableTypes).map(key => {
      if (key !== 'key') {
        columnData.push({
          id: key,
          numeric: true,
          float: 2,
          disablePadding: false,
          label: tableTypesMatcher(key)
        })
      }
      return null
    })
    this.setState({ columnData: columnData })
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.tableTypes !== this.props.tableTypes) {
      this.updateColumnData(nextProps.tableTypes)
    }
  }
  componentDidMount() {
    this.updateColumnData(this.props.tableTypes)
  }
  componentWillMount() {
    this.setState({ columnData: defaultColumnData })
  }
  render() {
    const { pricings } = this.props
    const { columnData } = this.state
    return (
      <div style={{ paddingTop: 24 }}>
        <AdminTableComponent
          title="Tarifs"
          selectable
          list={pricings}
          orderBy={'name'}
          columnData={columnData}
          addButtonAction={this.handleAddPricingClick}
          editButtonAction={this.handleEditPricingClick}
          deleteButtonAction={this.handleDeletePricingClick}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/Admin/Pricings/components/PricingsComponent.js